//
//
//
//
//




export default {
    name: 'software-version',

    data() {
        return {
            software_version: "",
        };
    },
    created() {
        this.software_version = process.env.VUE_APP_VERSION;
    },
    mounted() {

    },
    methods: {
    }
}
